const ValidationMixin = {
	data() {
		return {
			validationState: {},
		};
	},

	computed: {
		isValid() {
			let valid = true;
			Object.keys(this.validationState)
				.forEach(key => {
					if (!this.validationState[key].valid) {
						valid = false;
					}
				});
			return valid;
		},
		isValidationLoading() {
			let result = false;
			Object.keys(this.validationState)
				.forEach(key => {
					if (this.validationState[key].loading) {
						result = false;
					}
				});
			return result;
		},
		isDirty() {
			let dirty = false;
			Object.keys(this.validationState)
				.forEach(key => {
					if (this.validationState[key].dirty) {
						dirty = true;
					}
				});
			return dirty;
		},
	},

	methods: {
		onValidate(validation, prop) {
			if (typeof this.validationState[prop] === 'undefined') {
				this.validationState[prop] = validation;
			} else {
				const validationState = { ...this.validationState };
				validationState[prop] = validation;
				this.validationState  = validationState;
			}
		},
		validate() {
			return new Promise(resolve => {
				Object.keys(this.$refs)
					.forEach(inputName => {
						const input = Array.isArray(this.$refs[inputName])
							? this.$refs[inputName][0]
							: this.$refs[inputName];
						if (this.$core.utils.isObject(input) && typeof input.validateForce === 'function') {
							input.validateForce();
						}
					});
				this.$nextTick()
					.then(() => resolve());
			});
		},
		validationReset() {
			Object.keys(this.$refs)
				.forEach(inputName => {
					const input = Array.isArray(this.$refs[inputName])
						? this.$refs[inputName][0]
						: this.$refs[inputName];
					if (this.$core.utils.isObject(input) && typeof input.validationReset === 'function') {
						input.validationReset();
					}
				});
		},
	},
};

export default ValidationMixin;
